import { useEffect } from "react";

import { compressToBase64 } from "lz-string";
import { DataTableState } from "../components/UI/DataTable/DataTable";

export function compressDataTableState(state: DataTableState) {
	return compressToBase64(JSON.stringify(state));
}

export default function useQueryFromState(state: DataTableState) {
	useEffect(() => {
		const compressed = compressDataTableState(state);

		if (window.location.search === `?${compressed}`) return; // NB: Don't rapidly push the same state to the history API, it'll throttle "navigation" and prevent state updates for a little while

		const { pathname, hash } = window.location;

		window.history.replaceState(null, "", pathname + "?" + compressed + hash);
	}, [state]);
}
